<div class="seat-stepper">
  @if (isEmpty) {
    <div class="seat-stepper__empty">
      <span class="seat-stepper__empty-text">
        @if (riderCount > 0) {
          <span nz-icon nzType="check-circle" nzTheme="fill"></span>
          <span><strong>{{ riderCount }} unbooked rider{{ riderCount === 1 ? '' : 's' }}</strong> recorded — seat accounted for.</span>
        } @else {
          <span nz-icon nzType="info-circle" nzTheme="outline"></span>
          <span><strong>Empty</strong> in booking data — review the photos for anyone seated here.</span>
        }
      </span>
    </div>
  } @else {
    <div class="seat-stepper__legs">
      @for (leg of passengers; track leg.passenger.id; let i = $index) {
        <button
          type="button"
          class="seat-stepper__leg"
          [class.seat-stepper__leg--active]="leg.passenger.id === activePassengerId"
          [class.seat-stepper__leg--done]="leg.passenger.audited"
          [title]="legTitle(leg)"
          (click)="select.emit(leg.passenger.id)"
        >
          <span class="seat-stepper__index">{{ i + 1 }}</span>
          <span class="seat-stepper__name">{{ leg.passenger.customerName || 'Passenger' }}</span>
          @if (leg.originStop && leg.destinationStop) {
            <span class="seat-stepper__route">{{ leg.originStop.name }} → {{ leg.destinationStop.name }}</span>
          }
          @if (leg.passenger.audited) {
            <span class="seat-stepper__check" nz-icon nzType="check-circle" nzTheme="fill"></span>
          }
        </button>
      }
      @if (passengers.length > 1) {
        <span class="seat-stepper__counter">{{ activeOrdinal }} of {{ passengers.length }}</span>
      }
    </div>
  }
</div>
